import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary, colorTextStandard } from '@calendly/ui/theme';
import { useHistory } from 'react-router-dom';
import CalendarImgSrc from 'features/meetings/images/calendar.svg';
import { useHomeTabs } from 'hooks/home/tabs';

/* Match Figma Empty states copy: Body Bold 16 + body medium 14, centered. */
const noUpcomingContainerCss = "n1cm60qk";
const buttonWrapperCss = "b3olj9z";

/**
 * End-of-list / inline Upcoming empty card (AC2 copy).
 * CTA navigates to the Scheduling (event types) page.
 */
export const NoUpcomingMeetingsCard = () => {
  const history = useHistory();
  const {
    getTabPathByName
  } = useHomeTabs();
  return <div className={noUpcomingContainerCss} data-testid="no-upcoming-meetings-card">
      <img src={CalendarImgSrc} alt="" width="80" height="80" />
      <BodyText weight="bold" size="large" color={colorTextStandard}>
        {I18n.t('publisher.meetings.empty_state.all_caught_up')}
      </BodyText>
      <BodyText size="medium" color={colorTextSecondary}>
        {I18n.t('publisher.meetings.empty_state.all_caught_up_description')}
      </BodyText>
      <div className={buttonWrapperCss}>
        <Button appearance="secondary-outline" size="medium" label={I18n.t('publisher.meetings.empty_state.schedule_a_meeting')} responsive={false} onClick={() => history.push(getTabPathByName('event_types'))} />
      </div>
    </div>;
};

require("./NoUpcomingMeetingsCard.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./NoUpcomingMeetingsCard.tsx");